/* eslint-disable */
import OsmMapHelper from "../OsmMapHelper";
import ItemListBase from "./ItemListBase";
import ItemOsmMap from "../item/ItemOsmMap";
import ItemSettingBuilding from "../item_setting/ItemSettingBuilding";

class ItemListBuilding extends ItemListBase {
  constructor(scene) {
    super(scene);

    this.name = "ItemListBuilding";

    super.createRoot();
  }

  create(acc, data, position, size, boundary) {
    data.forEach((item, index) => {
      if (item.nodes) {
        //get mesh spec
        let meshSpec = {};

        if (item.tags["building"]) {
          meshSpec = this.getMeshSpec("building", item.tags["building"]);

          if (item.tags["building:levels"]) {
            meshSpec.depth = item.tags["building:levels"] * 0.025;

            if (meshSpec.depth > 0.5) meshSpec.depth = 0.5;
          }
        } else if (item.tags["tourism"]) {
          meshSpec = this.getMeshSpec("tourism", item.tags["tourism"]);
        } else if (item.tags["amenity"]) {
          meshSpec = this.getMeshSpec("amenity", item.tags["amenity"]);
        } else if (item.tags["landuse"]) {
          meshSpec = this.getMeshSpec("landuse", item.tags["landuse"]);
        } else if (item.tags["natural"]) {
          meshSpec = this.getMeshSpec("natural", item.tags["natural"]);
        } else if (item.tags["leisure"]) {
          meshSpec = this.getMeshSpec("leisure", item.tags["leisure"]);
        } else if (item.tags["waterway"]) {
          meshSpec = this.getMeshSpec("waterway", item.tags["waterway"]);
        } else {
          meshSpec.create = false;
        }

        ////console.log(item.tags.name);
        ////console.log(meshSpec);
        if (meshSpec.create) {
          let points = OsmMapHelper.getPoints(
            acc,
            item,
            position,
            size,
            boundary
          );

          if (points.length > 3) {
            //create mesh
            let faceColors = [];
            faceColors[0] = meshSpec.color;
            faceColors[1] = meshSpec.color;
            faceColors[2] = meshSpec.color;

            let mesh = BABYLON.MeshBuilder.ExtrudePolygon(
              this.name + "_" + index,
              {
                shape: points,
                holes: [],
                depth: meshSpec.depth,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE,
                faceColors: faceColors
              },
              this.scene
            );

            mesh.parent = this.root;

            mesh.material = super.createMaterial(
              this.name + "_" + index,
              null,
              meshSpec.metallic,
              meshSpec.roughness
            );

            this.meshList.push(new ItemOsmMap(this.scene, mesh));
          }
        }
      }
    });
  }

  //MESHのdepth・material設定を取得
  getMeshSpec(type, value) {
    //console.log(type, value);

    let create = true;
    let color = new BABYLON.Color3(0.75, 0.75, 0.75);
    let metallic = 0.5 + Math.random() * 0.5;
    let roughness = 0.2 + Math.random() * 0.1;
    let depth = 0;

    let check;

    if (ItemSettingBuilding.buildingType[type][value]) {
      check = ItemSettingBuilding.buildingType[type][value];
    } else {
      check = ItemSettingBuilding.buildingType[type]["default"];
    }

    if (check.create !== undefined) create = check.create;
    if (check.depth !== undefined) depth = check.depth;
    if (check.color !== undefined) color = check.color;
    if (check.metallic !== undefined) metallic = check.metallic;
    if (check.roughness !== undefined) roughness = check.roughness;

    return {
      create: create,
      depth: depth,
      color: color,
      metallic: metallic,
      roughness: roughness
    };
  }
}
export default ItemListBuilding;
